import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4H20C21.11 4 22 4.89 22 6V18C22 19.11 21.11 20 20 20H4C2.89 20 2 19.11 2 18L2.01 6C2.01 4.89 2.89 4 4 4ZM4 18H20V10.5H4V18ZM20 6V8H4V6H20ZM4.9 15.9H13.9V13.2H4.9V15.9Z"
      fill={fill}
    />
    <mask
      id="mask0_0_46300"
      maskUnits="userSpaceOnUse"
      x="2"
      y="4"
      width="20"
      height="16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4H20C21.11 4 22 4.89 22 6V18C22 19.11 21.11 20 20 20H4C2.89 20 2 19.11 2 18L2.01 6C2.01 4.89 2.89 4 4 4ZM4 18H20V10.5H4V18ZM20 6V8H4V6H20ZM4.9 15.9H13.9V13.2H4.9V15.9Z"
        fill={fill}
      />
    </mask>
  </g>
);

export default Icon;
